import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("pg_token");
    if (!t) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setRestaurant(data.restaurant);
    } catch { logout(); }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pg_token", data.token);
    setUser(data.user); setRestaurant(data.restaurant);
    return data;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("pg_token", data.token);
    setUser(data.user); setRestaurant(data.restaurant);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("pg_token");
    setUser(null); setRestaurant(null);
  };

  return (
    <AuthContext.Provider value={{ user, restaurant, loading, login, signup, logout, refresh, setRestaurant }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const PLAN_FEATURES = {
  free: new Set(["menu","orders_basic","public_menu","qrcode","customers_basic","reports_basic","branding_basic"]),
  essencial: new Set(["menu","orders_basic","public_menu","qrcode","customers_basic","reports_basic","products_unlimited","coupons","promotions","inventory_basic","cash_register","payments","reports_daily","reports_monthly","expenses","revenues","accounts_payable","accounts_receivable","cash_close","pos_basic","print_orders","users_basic","brand_custom"]),
  profissional: new Set(),
  master: new Set(),
};
// profissional & master inherit — treat "has" via API rejection on backend; frontend just hints
export const hasFeature = (plan, feat) => {
  if (plan === "master" || plan === "profissional") return true;
  if (plan === "essencial") return PLAN_FEATURES.essencial.has(feat) || PLAN_FEATURES.free.has(feat);
  return PLAN_FEATURES.free.has(feat);
};
